const homeHeroForm = document.querySelector( '#home-hero-form' );
const homeHeroSelect = document.querySelector( '#home-hero-select' );

if ( homeHeroForm ) {

  homeHeroForm.addEventListener( 'submit', function ( event ) {

    if ( homeHeroSelect.value === '0' ) {

      event.preventDefault();

      homeHeroSelect.focus();

    }

  } );

}
